import './scss/main.scss';
import './js/scripts';
import './js/global/header';
import './js/global/footer';
